<ng-container *ngIf="projectPlacement.appointment">
  <div class="mb-0 mt-3">
    <span class="preserve-line-break display-contents"
      >Afspraak:
      <span class="strong inline-flex">{{
        projectPlacement.needAppointmentInfo | or: 'Ja'
      }}</span></span
    >
  </div>
  <div *ngIf="appointmentContactInfoDisplay?.length > 0" class="mb-0">
    Afspraak met makelaar: <b>{{ appointmentContactInfoDisplay }}</b>
  </div>
  <div *ngIf="appointmentWithCustomerDisplay?.length > 0" class="mb-0">
    Afspraak met eigenaar/bewoner: <b>{{ appointmentWithCustomerDisplay }}</b>
  </div>
</ng-container>
<div
  *ngIf="projectPlacement.collectKey"
  [class.mt-3]="!projectPlacement.appointment"
>
  <span class="preserve-line-break display-contents"
    >Sleutel afhalen:
    <span class="strong inline-flex">{{
      appointmentCollectKeyFromDisplay | or: 'Ja'
    }}</span></span
  >
</div>
